import { getStoredToken } from '../auth/cognito';

const API_URL = 'https://ucw7umyds6.execute-api.ca-central-1.amazonaws.com/prod/results';
const ADMIN_API_URL = 'https://0emko5cw6f.execute-api.ca-central-1.amazonaws.com/prod';

export interface AssessmentResult {
  userId: string;
  assessmentId: string;
  assessmentType: 'tabletop' | 'engineering';
  moduleId: string;
  score: number;
  answers: number[];
  isComplete: boolean;
  completedAt: string;
}

function getAuthHeaders() {
  const token = getStoredToken();
  return {
    'Content-Type': 'application/json',
    'Authorization': token || ''
  };
}

export type OrgPlan = 'starter' | 'professional' | 'enterprise';

export async function getOrgPlan(): Promise<{ plan: OrgPlan; orgName: string; status: string; orgId: string | null }> {
  try {
    const res = await fetch(`${ADMIN_API_URL}/org/plan`, { headers: getAuthHeaders() });
    const data = await res.json();
    return { plan: data.plan || 'starter', orgName: data.orgName || '', status: data.status || 'active', orgId: data.orgId || null };
  } catch {
    return { plan: 'starter', orgName: '', status: 'active', orgId: null };
  }
}

export async function saveResult(data: {
  assessmentType: 'tabletop' | 'engineering';
  moduleId: string;
  score: number;
  answers: number[];
  isComplete: boolean;
}): Promise<void> {
  try {
    await fetch(API_URL, {
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify(data)
    });
  } catch (err) {
    console.error('Failed to save result:', err);
  }
}

export async function getResults(): Promise<AssessmentResult[]> {
  try {
    const res = await fetch(API_URL, {
      method: 'GET',
      headers: getAuthHeaders()
    });
    const data = await res.json();
    return data.results || [];
  } catch (err) {
    console.error('Failed to fetch results:', err);
    return [];
  }
}

export function getCompletedCount(results: AssessmentResult[]): number {
  return results.filter(r => r.isComplete).length;
}

export function getLatestScore(results: AssessmentResult[]): number | null {
  const completed = results.filter(r => r.isComplete);
  if (completed.length === 0) return null;
  return completed[0].score;
}

export function getAssessmentHistory(results: AssessmentResult[]) {
  const completed = results.filter(r => r.isComplete);
  return completed.map(r => ({
    type: r.assessmentType === 'tabletop' ? 'Privacy Tabletop' : 'Privacy Engineering',
    score: r.score,
    date: new Date(r.completedAt).toLocaleDateString('en-CA', { month: 'short', day: 'numeric', year: 'numeric' }),
    risk: r.score >= 80 ? 'Low' : r.score >= 50 ? 'Medium' : 'High',
    riskColor: r.score >= 80 ? '#22c55e' : r.score >= 50 ? '#f97316' : '#ef4444'
  }));
}